/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { AccountResendEmailForm } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GenericResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { UpdateUserPasswordForm } from '../model/models';
import { UserEmailRequest } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface ResendEmailAccountRequestParams {
    accountResendEmailForm: AccountResendEmailForm;
}

export interface ResetNotMeAccountRequestParams {
    token: string;
    xRecaptchaToken?: string;
}

export interface ResetPasswordAccountRequestParams {
    userEmailRequest: UserEmailRequest;
    xRecaptchaToken?: string;
}

export interface UpdatePasswordAccountRequestParams {
    updateUserPasswordForm: UpdateUserPasswordForm;
    xRecaptchaToken?: string;
}

export interface VerifyAccountRequestParams {
    updateUserPasswordForm: UpdateUserPasswordForm;
    xRecaptchaToken?: string;
}


export interface AccountServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Re-invia un\&#39;email di account (recovery o verifica).
     * Re-invia l\&#39;email di recovery password (RESEND_RECOVERY_EMAIL) o di verifica account (RESEND_VERIFICATION_EMAIL). Assorbe il legacy POST /resend. Endpoint pubblico. Il flusso verifica email NON si applica agli utenti CITTADINO federati (autenticazione SPID/CIE-ID).
     * @endpoint post /api/v1/account/resend-email
* @param requestParameters
     */
    resendEmailAccount(requestParameters: ResendEmailAccountRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Annulla la procedura di reset password (\&quot;Non sono stato io\&quot;).
     * Invocata dall\&#39;utente tramite link ricevuto via mail. Invalida ENTRAMBI i token di reset senza modificare la password. Endpoint pubblico, non richiede autenticazione.
     * @endpoint put /api/v1/account/reset-not-me
* @param requestParameters
     */
    resetNotMeAccount(requestParameters: ResetNotMeAccountRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Richiede il reset della password dell\&#39;utente.
     * Avvia il processo di reset password per l\&#39;utente con l\&#39;email specificata, inviando un link via email. Endpoint pubblico, non richiede autenticazione. Ritorna sempre 200 (non rivela se l\&#39;email esiste).
     * @endpoint put /api/v1/account/reset-password
* @param requestParameters
     */
    resetPasswordAccount(requestParameters: ResetPasswordAccountRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Aggiorna la password dell\&#39;utente.
     * Imposta la nuova password per l\&#39;utente tramite il token ricevuto via email durante il processo di reset. Endpoint pubblico, non richiede autenticazione.
     * @endpoint put /api/v1/account/update-password
* @param requestParameters
     */
    updatePasswordAccount(requestParameters: UpdatePasswordAccountRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Verifica un nuovo account e ne imposta la password iniziale.
     * Completa la verifica dell\&#39;account impostando la password iniziale tramite il token ricevuto via email al momento della registrazione. Endpoint pubblico, non richiede autenticazione.
     * @endpoint put /api/v1/account/verification
* @param requestParameters
     */
    verifyAccount(requestParameters: VerifyAccountRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

}
